import { Helmet } from "react-helmet-async";
import { SITE_URL } from "@/lib/constants";

export default function SEO({ title, description, path = "/", jsonLd = null, image = null }) {
  const fullTitle = title || "BROX CONSTRUCT — Un singur contact. Tot proiectul.";
  const desc = description || "Punctul unic de contact pentru construcții, renovări, instalații și lucrări exterioare. Ne spui ce ai nevoie — organizăm oamenii, materialele și execuția.";
  const canonical = `${SITE_URL}${path === "/" ? "" : path}`;
  const ogImage = image || `${SITE_URL}/og-image.jpg`;
  return (
    <Helmet>
      <html lang="ro" />
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="BROX CONSTRUCT" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="ro_RO" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}

export const organizationJsonLd = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#business`,
  name: "BROX CONSTRUCT",
  legalName: "Brox Consulting S.R.L.",
  url: SITE_URL,
  logo: `${SITE_URL}/og-image.jpg`,
  image: `${SITE_URL}/og-image.jpg`,
  telephone: "+40725358058",
  email: "broxconsultingsrl@gmail.com",
  description:
    "Brox Construct este punctul unic de contact între clienți, echipe de construcții, firme specializate și furnizori de materiale.",
  areaServed: ["Arad", "Timiș", "Hunedoara"],
  address: { "@type": "PostalAddress", addressRegion: "Timiș", addressCountry: "RO" },
  sameAs: ["https://www.instagram.com/broxconstruct", "https://www.tiktok.com/@broxconstruct"],
};
